import { ColumnDescription } from "react-bootstrap-table-next";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import {
    DeletarMotivoCompraController,
    InserirMotivoCompraController,
    ListarMotivoCompraController,
} from "../../../../../Controllers/Geral/GestaoDeCadastros/MotivoCompra/MotivoCompraControllers";
import Swal from "sweetalert2";
import { IMotivoCompra } from "../../../../../Interfaces/Geral/GestaoDeCadastro/MotivoCompra/MotivoCompraInterfaces";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import UnForm from "../../../../Form";
import Table from "../../../../Table";
import OrSpinner from "../../../../Utils/OrSpinner";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";

interface IListagemMotivoCompra {
    setEdit: (tpa: IMotivoCompra) => void;
}

export default function MotivoCompra(props: IListagemMotivoCompra) {
    const {
        value: listarMotivosCompra,
        execute: LstMotivoCompra,
        loading: lstMotivosCompraLoading,
    } = useAsyncEffect(() => ListarMotivoCompraController(), []);

    const {
        execute: InserirMotivoCompra,
        loading: inserirMotivoCompraLoading,
    } = useAsyncCallback(InserirMotivoCompraController, []);

    const handleMotivoCompraFormSubmit = (formData: IMotivoCompra) => {
        InserirMotivoCompra({
            ...formData,
            DS_MOTIVO_COMPRA: formData.DS_MOTIVO_COMPRA,
        }).then(() => {
            updateLstMotivoCompra();
        });
    };

    function updateLstMotivoCompra() {
        LstMotivoCompra();
    }

    //Tabela
    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_MOTIVO_COMPRA",
            text: "Motivo Compra",
            formatter: rowMotivoCompra,
            sort: true,
        },
        {
            dataField: "button",
            text: "Deletar",
            isDummyField: true,
            formatter: (_, row) => (
                <div className="d-flex justify-content-center align-items-center">
                    <div>
                        {
                            <button
                                className="btn btn-sm btn-outline-danger font-weight-bold"
                                onClick={() => {
                                    Swal.fire({
                                        title: "Deseja apagar este Motivo Compra?",
                                        icon: "info",
                                        buttonsStyling: false,
                                        confirmButtonText:
                                            "<i class='la la-check'></i> Sim!",
                                        showCancelButton: true,
                                        cancelButtonText:
                                            "<i class='la la-thumbs-down'></i> Não",
                                        customClass: {
                                            confirmButton:
                                                "btn btn-outline-success",
                                            cancelButton: "btn btn-default",
                                        },
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            DeletarMotivoCompraController(
                                                row.ID_MOTIVO_COMPRA
                                            ).then(() => {
                                                updateLstMotivoCompra();
                                            });
                                        }
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} size="lg" />
                            </button>
                        }
                    </div>
                </div>
            ),
        },
    ];

    function rowMotivoCompra(cell: string, row: IMotivoCompra) {
        return (
            <div className="rowCapysTCA d-flex justify-content-between align-items-center mr-5">
                <div>
                    <label className="mb-1">{row.DS_MOTIVO_COMPRA}</label>

                    <div>
                        {row.DS_MOTIVO_COMPRA && (
                            <>
                                <span
                                    className={`label abel-pill label-inline label-primary`}
                                >
                                    {row.ID_MOTIVO_COMPRA} {"-"}{" "}
                                    {row.DS_MOTIVO_COMPRA}
                                </span>
                            </>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="d-flex flex-columns row">
                <div className="col-12 collapse mb-5" id="collapseForm">
                    <h5 className="text-center">CADASTRO DE MOTIVO COMPRA</h5>
                    <UnForm
                        handleSubmit={handleMotivoCompraFormSubmit}
                        className="col"
                    >
                        <UnForm.Input
                            name="DS_MOTIVO_COMPRA"
                            required
                            label="Descrição motivo de compra"
                            wrapperClassName="col-6"
                        />
                        <div
                            className="d-flex justify-content-center"
                            style={{ marginLeft: "70px" }}
                        >
                            <UnForm.SubmitButton
                                color="success"
                                icon={faPlus}
                                loading={inserirMotivoCompraLoading}
                                wrapperClassName="col-6"
                                className="d-flex justify-content-center align-items-center"
                            >
                                Cadastrar Motivo Compra
                            </UnForm.SubmitButton>
                        </div>
                    </UnForm>
                </div>

                <div className="col-12 mt-5">
                    <OrSpinner
                        loading={lstMotivosCompraLoading}
                        spinner="capys"
                    >
                        <Table
                            keyField="ID_MOTIVO_COMPRA"
                            columns={columns}
                            data={listarMotivosCompra ?? []}
                            sizePerPage={10}
                            loading={lstMotivosCompraLoading}
                            noDataIndication={
                                <div className="text-center text-muted">
                                    Nenhum Motivo Compra
                                </div>
                            }
                            wrapperClasses="wrapperTable mw-100 x-scroll"
                            classes="tableClasses"
                            bordered={false}
                            center
                            defaultStyle={{
                                align: "center",
                                classes: "p-2",
                            }}
                        />
                    </OrSpinner>
                </div>
            </div>
        </>
    );
}
